<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

<div class="container pt-5">
  <div class="row justify-content-start">
    <div class="col-12">
      <div class="text-lg-start mb-4">
        <h3 class="mb-3 font-weight-normal">
          {{mode === 'update' ? 'Update Vendor' : mode === 'view' ? 'View Vendor' : 'Add Vendor'}}
        </h3>
      </div>

      <main class="form-signin border p-4 rounded">
        <form [formGroup]="addVendorForm" (ngSubmit)="submit()">

          <div class="row mb-3">
            <div class="col-md-6">
              <div class="form-floating">
                <input
                  formControlName="vendorName"
                  id="vendorName"
                  type="text"
                  placeholder="Vendor Name"
                  class="form-control"
                  [class.is-invalid]="submitted && addVendorForm.get('vendorName')?.errors">

                <label for="vendorName">Vendor Name</label>

                <span class="text-danger"
                  *ngIf="submitted && addVendorForm.get('vendorName')?.hasError('required')">
                  Vendor Name is required
                </span>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-floating">
                <input
                  formControlName="gstNo"
                  id="gstNo"
                  type="text"
                  placeholder="GST No"
                  class="form-control"
                  [class.is-invalid]="submitted && addVendorForm.get('gstNo')?.errors">

                <label for="gstNo">GST No</label>

                <span class="text-danger"
                  *ngIf="submitted && addVendorForm.get('gstNo')?.hasError('required')">
                  GST No is required
                </span>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-6">
              <div class="form-floating">
                <input
                  formControlName="address"
                  id="address"
                  type="text"
                  placeholder="Address"
                  class="form-control"
                  [class.is-invalid]="submitted && addVendorForm.get('address')?.errors">

                <label for="address">Address</label>

                <span class="text-danger"
                  *ngIf="submitted && addVendorForm.get('address')?.hasError('required')">
                  Address is required
                </span>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-floating">
                <input
                  formControlName="contactNo"
                  id="contactNo"
                  type="text"
                  placeholder="Contact No"
                  class="form-control"
                  [class.is-invalid]="submitted && addVendorForm.get('contactNo')?.errors">

                <label for="contactNo">Contact No</label>

                <span class="text-danger"
                  *ngIf="submitted && addVendorForm.get('contactNo')?.hasError('required')">
                  Contact No is required
                </span>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-6">
              <div class="form-floating">
                <input
                  formControlName="bankName"
                  id="bankName"
                  type="text"
                  placeholder="Bank Name"
                  class="form-control">

                <label for="bankName">Bank Name</label>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-floating">
                <input
                  formControlName="bankAccountNo"
                  id="bankAccountNo"
                  type="text"
                  placeholder="Bank Account Number"
                  class="form-control">

                <label for="bankAccountNo">Bank Account Number</label>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-6">
              <div class="form-floating">
                <input
                  formControlName="bankIfscCode"
                  id="bankIfscCode"
                  type="text"
                  placeholder="Bank IFSC Code"
                  class="form-control">

                <label for="bankIfscCode">Bank IFSC Code</label>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-floating">
                <input
                  formControlName="bankBranchName"
                  id="bankBranchName"
                  type="text"
                  placeholder="Bank Branch Name"
                  class="form-control">

                <label for="bankBranchName">Branch Name</label>
              </div>
            </div>
          </div>

          <div *ngIf="mode !== 'view'" class="d-grid mt-4 px-1">
            <button
              class="btn btn-lg btn-info"
              type="submit"
              [disabled]="isSubmitDisabled || addVendorForm.invalid">

              {{mode === 'update' ? 'Update Vendor' : 'Add Vendor'}}
            </button>
          </div>

        </form>
      </main>
    </div>
  </div>

  <!-- Vendor Members Section -->
  <div
    class="row justify-content-start mt-5"
    *ngIf="(mode === 'update' || mode === 'view') && addVendorForm.get('id')?.value">

    <div class="col-12">

      <div class="text-lg-start mb-4">
        <h4 class="mb-3 font-weight-normal">Vendor Members</h4>
      </div>

      <!-- Members List -->
      <div *ngIf="vendorMembers.length > 0" class="mb-4">

        <div
          *ngFor="let member of vendorMembers; let i = index"
          class="border mb-3 rounded">

          <!-- Header -->
          <div
            class="p-3 bg-light d-flex justify-content-between align-items-center member-header"
            (click)="toggleVendorMemberExpanded(i)">

            <div class="d-flex align-items-center flex-grow-1">
              <i class="material-icons me-2">
                {{expandedVendorMembers[i] ? 'expand_less' : 'expand_more'}}
              </i>

              <span class="font-weight-bold">
                {{member.memberName || 'New Vendor Member'}}
              </span>
            </div>
          </div>

          <!-- Expanded -->
          <div *ngIf="expandedVendorMembers[i]" class="p-4 border-top">

            <div class="row mb-3">

              <div class="col-md-6">
                <div class="form-floating">
                  <input
                    [(ngModel)]="member.memberName"
                    type="text"
                    placeholder="Member Name"
                    class="form-control"
                    [disabled]="mode === 'view' || !member.isEditing">

                  <label>Member Name</label>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-floating">
                  <input
                    [(ngModel)]="member.designation"
                    type="text"
                    placeholder="Designation"
                    class="form-control"
                    [disabled]="mode === 'view' || !member.isEditing">

                  <label>Designation</label>
                </div>
              </div>

            </div>

            <div class="row mb-3">

              <div class="col-md-6">
                <div class="form-floating">
                  <input
                    [(ngModel)]="member.email"
                    type="email"
                    placeholder="Email"
                    class="form-control"
                    [disabled]="mode === 'view' || !member.isEditing">

                  <label>Email</label>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-floating">
                  <input
                    [(ngModel)]="member.mobile"
                    type="text"
                    placeholder="Mobile"
                    class="form-control"
                    [disabled]="mode === 'view' || !member.isEditing">

                  <label>Mobile</label>
                </div>
              </div>

            </div>

            <div class="row mb-3">

              <div class="col-md-6">
                <div class="form-floating">
                  <select
                    [(ngModel)]="member.pmoc"
                    class="form-control"
                    [disabled]="mode === 'view' || !member.isEditing">

                    <option value="email">Email</option>
                    <option value="call">Call</option>
                    <option value="whatsapp">WhatsApp</option>
                  </select>

                  <label>PMOC</label>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-floating">
                  <input
                    [(ngModel)]="member.skypeId"
                    type="text"
                    placeholder="Skype ID"
                    class="form-control"
                    [disabled]="mode === 'view' || !member.isEditing">

                  <label>Skype ID</label>
                </div>
              </div>

            </div>

            <div class="row mb-3">

              <div class="col-md-6">
                <div class="form-floating">
                  <input
                    [(ngModel)]="member.telephone"
                    type="text"
                    placeholder="Telephone"
                    class="form-control"
                    [disabled]="mode === 'view' || !member.isEditing">

                  <label>Telephone</label>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-check mt-3">
                  <input
                    [(ngModel)]="member.isWhatsApp"
                    type="checkbox"
                    class="form-check-input"
                    [disabled]="mode === 'view' || !member.isEditing">

                  <label class="form-check-label">
                    Is WhatsApp
                  </label>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-check mt-3">
                  <input
                    [(ngModel)]="member.isMainSeller"
                    type="checkbox"
                    class="form-check-input"
                    [disabled]="mode === 'view' || !member.isEditing">

                  <label class="form-check-label">
                    Is Main Seller
                  </label>
                </div>
              </div>

            </div>

            <!-- Buttons -->
            <div *ngIf="mode !== 'view'" class="mt-4 d-flex">

              <button
                type="button"
                *ngIf="!member.isEditing"
                (click)="editVendorMember(member)"
                class="btn btn-sm btn-warning me-2">

                Edit
              </button>

              <button
                type="button"
                *ngIf="member.isEditing"
                (click)="saveMember(member)"
                class="btn btn-sm btn-success me-2">

                Save
              </button>

              <button
                type="button"
                *ngIf="member.isEditing"
                (click)="cancelVendorMember(i, member)"
                class="btn btn-sm btn-secondary me-2">

                Cancel
              </button>

              <button
                type="button"
                *ngIf="!member.isEditing"
                (click)="deleteVendorMember(i, member)"
                class="btn btn-sm btn-danger">

                Delete
              </button>

            </div>

          </div>
        </div>
      </div>

      <!-- Add Button -->
      <div *ngIf="mode !== 'view'" class="d-grid mt-3 px-1">
        <button
          type="button"
          (click)="addVendorMember()"
          class="btn btn-outline-info">

          Add More Vendor Member
        </button>
      </div>

      <!-- Empty State -->
      <div
        *ngIf="vendorMembers.length === 0 && (mode === 'update' || mode === 'view')"
        class="alert alert-info">

        No vendor members added yet.

        <button
          type="button"
          *ngIf="mode !== 'view'"
          (click)="addVendorMember()"
          class="btn btn-sm btn-info ms-2">

          Add Vendor Member
        </button>

      </div>

    </div>
  </div>
</div>